module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Git2-14204a397d0d719643802614be4b9cae.svg";